module.exports = __webpack_public_path__ + "static/img/A34.8499253e.jpg";